/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Verfügbarkeit für ${i.count} Nächte mit`
};

const en_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Availabilities for ${i.count} nights`
};

const es_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Disponibilidad para ${i.count} noches con`
};

const fr_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Disponibilité pour ${i.count} nuits avec`
};

const it_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Disponibilità per ${i.count} pernottamenti con`
};

const nl_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Beschikbaarheid voor ${i.count} nachten met`
};

const pt_poi_datasheet__availabilities__many__overnight_stay = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Disponibilidade para ${i.count} noites com`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__many__overnight_stay = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__availabilities__many__overnight_stay(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__availabilities__many__overnight_stay", locale)
	if (locale === "de") return de_poi_datasheet__availabilities__many__overnight_stay(inputs)
	if (locale === "en") return en_poi_datasheet__availabilities__many__overnight_stay(inputs)
	if (locale === "es") return es_poi_datasheet__availabilities__many__overnight_stay(inputs)
	if (locale === "fr") return fr_poi_datasheet__availabilities__many__overnight_stay(inputs)
	if (locale === "it") return it_poi_datasheet__availabilities__many__overnight_stay(inputs)
	if (locale === "nl") return nl_poi_datasheet__availabilities__many__overnight_stay(inputs)
	return pt_poi_datasheet__availabilities__many__overnight_stay(inputs)
};